import { Box } from '@mui/material';
import styled from 'styled-components';

export const defaultFormControlStyle = {
  backgroundColor: '#fff',
  borderRadius: '10px',
  fontSize: '14px',
  lineHeight: '1.5',
  '& input': {
    fontSize: '14px',
    lineHeight: '1.5',
  },
};

export const defaultStyleIcon = {
  fill: '#A3A7B0',
  '&:hover': {
    fill: '#44AEFB',
  },
};

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(0.5),
}));
